import { Controller } from "@hotwired/stimulus";
import { post } from "@rails/request.js";

// Beacons the one step of the filter waterfall that needs a person. Deliberately fire-and-forget and not
// awaited: the same click also opens Mo via ui--open-mo, and a slow or failed beacon must never delay or
// block that.
export default class extends Controller {
  static values = { url: String, filter: String };

  track() {
    post(this.urlValue, {
      body: { filter: this.filterValue },
      responseKind: "turbo-stream",
    }).catch(() => {});
  }
}
